export const NAME = 'multi-panel-layout';
